import React, { useState, useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import './Header.css';

const LINKEDIN_URL = 'https://www.linkedin.com/company/pysolutions-dev';

const LinkedInIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
  </svg>
);

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const onNavClick = () => {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
    setIsMobileMenuOpen(false);
  };

  return (
    <header className={`header ${isScrolled ? 'header-scrolled' : ''}`}>
      <div className="container">
        <div className="header-content">
          {/* Logo */}
          <Link to="/" className="logo" onClick={onNavClick} aria-label="PySolutions home">
            <img src="/PySolutions.jpeg" alt="PySolutions" className="logo-image" width="32" height="32" decoding="async" fetchpriority="high" />
            <span className="logo-text">
              <span className="py-text">Py</span>Solutions
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="nav-desktop">
            <Link
              to="/"
              onClick={onNavClick}
              className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}
            >
              Home
            </Link>
            <Link
              to="/about"
              onClick={onNavClick}
              className={`nav-link ${location.pathname === '/about' ? 'active' : ''}`}
            >
              About
            </Link>
            <Link
              to="/contact"
              onClick={onNavClick}
              className={`nav-link ${location.pathname === '/contact' ? 'active' : ''}`}
            >
              Contact
            </Link>
            <Link
              to="/blog"
              onClick={onNavClick}
              className={`nav-link ${location.pathname.startsWith('/blog') ? 'active' : ''}`}
            >
              Blog
            </Link>
          </nav>

          <div className="header-actions">
            {/* LinkedIn icon button */}
            <a
              href={LINKEDIN_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="header-linkedin"
              aria-label="PySolutions on LinkedIn"
            >
              <LinkedInIcon />
            </a>

            {/* CTA Button */}
            <Link to="/contact" onClick={onNavClick} className="header-cta">
              Get Started
              <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5-5 5M6 12h12" />
              </svg>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="mobile-menu-button"
            onClick={toggleMobileMenu}
            aria-label="Toggle mobile menu"
          >
            <span className={`hamburger ${isMobileMenuOpen ? 'open' : ''}`}>
              <span></span>
              <span></span>
              <span></span>
            </span>
          </button>
        </div>

        {/* Mobile Navigation */}
        <nav className={`nav-mobile ${isMobileMenuOpen ? 'open' : ''}`}>
          <div className="mobile-nav-content">
            <Link
              to="/"
              onClick={onNavClick}
              className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}
              style={{ width: '100%', textAlign: 'left' }}
            >
              Home
            </Link>
            <Link
              to="/about"
              onClick={onNavClick}
              className={`nav-link ${location.pathname === '/about' ? 'active' : ''}`}
              style={{ width: '100%', textAlign: 'left' }}
            >
              About
            </Link>
            <Link
              to="/contact"
              onClick={onNavClick}
              className={`nav-link ${location.pathname === '/contact' ? 'active' : ''}`}
              style={{ width: '100%', textAlign: 'left' }}
            >
              Contact
            </Link>
            <Link
              to="/blog"
              onClick={onNavClick}
              className={`nav-link ${location.pathname.startsWith('/blog') ? 'active' : ''}`}
              style={{ width: '100%', textAlign: 'left' }}
            >
              Blog
            </Link>
            <a
              href={LINKEDIN_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="nav-link nav-link-linkedin"
              style={{ width: '100%', textAlign: 'left', display: 'inline-flex', alignItems: 'center', gap: '0.5rem' }}
              onClick={() => setIsMobileMenuOpen(false)}
              aria-label="PySolutions on LinkedIn"
            >
              <span style={{ width: '18px', height: '18px', display: 'inline-flex' }}>
                <LinkedInIcon />
              </span>
              LinkedIn
            </a>
            <Link
              to="/contact"
              onClick={onNavClick}
              className="header-cta mobile-cta"
            >
              Get Started
            </Link>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
